module.exports = __webpack_public_path__ + "img/i01-check.1e86898a.svg";